import FBG from "../assets/image/footerbg.png"
import Logo from "../assets/image/logo.png"
import Rect from '../assets/image/Rectangle.png'
import RBI from '../assets/image/rbi.png'
export default function Footer() {
    return(
        <footer className="bg-black bg-cover bg-center text-white h-full w-full py-[72px]"
        style={{ backgroundImage: `url(${FBG})` }} >
        
           {/*<img 
                    src={FBG} 
                    alt="" 
                    className="absolute object-contain opacity-100
                     bottom-0  left-0 right-0 w-full z-10
                    "
                  />*/}
                 
  <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-12"
  >

    {/* Top Section */}
    <div className="flex flex-col max-w-[1280px] items-center w-full gap-[42px] sm:gap-[48px] z-20">
      <div className="flex  items-center w-fit h-fit gap-4  ">
        <div className="w-fit h-fit items-center justify-center">
          <img  src={Logo} className=" w-[50px] h-[50px] sm:w-[68px] sm:h-[68px] md:w-[51px] md:h-[51px]  lg:w-[68px] lg:h-[68px] rounded"/>
        </div>
        <div className=" text-[41px] sm:text-[61px] md:text-[41px] lg:text-[61px] font-inter font-normal">Reap Capital</div>
      </div>

      <div className=" border-t border-b w-full h-fit flex flex-col md:flex-row gap-3 md:gap-0  justify-between border-gray-800 pb-[24px] pt-[24px] text-center text-white font-normal text-[14px]">
      <p> All copyrights reserve at @ReapCapital</p>
           <a href="/terms-and-conditions" className="text-[#0BA36C] z-40 hover:text-[#0BA36C] hover:underline">
  Terms and Conditions
</a>


    </div>

    </div>

    {/* Bottom Text */}
    

  </div>
</footer>

    )

}